import { Link, NavLink } from "react-router-dom"
import ComingSoon from "../../../components/ComingSoon"

export default function ForumPage() {
    return (
        <>
            {/* <!-- start page title --> */}
            <div className="row">
                <div className="col-12">
                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                        <h4 className="mb-sm-0">Forum
                            <span className="text-info text-capitalize" style={{ fontSize: '12px', fontWeight: '500', marginLeft: '10px'}}>
                                (This feature will be available with the next release).
                            </span>
                        </h4>

                        <div className="page-title-right">
                            <ol className="breadcrumb m-0">
                                <li className="breadcrumb-item"><Link to="/app">Dashboard</Link></li>
                                <li className="breadcrumb-item active">Forum</li>
                            </ol>
                        </div>

                    </div>
                </div>
            </div>
            {/* <!-- end page title --> */}

            {1==0 ?
                <div className="row">
                    <div className="col-lg-12">
                        <div className="card">
                            <div className="card-header align-items-center d-flex">
                                <h4 className="card-title mb-0 flex-grow-1"></h4>
                            </div>
                            {/* <!-- end card header --> */}
    
                            <div className="card-body">
    
                                {/* <p className="text-muted mb-4">The images or other media can be aligned top, middle, or bottom. The default is top aligned.</p> */}
    
                                <div className="live-preview">
                                    <div className="d-flex align-items-start text-muted mb-4">
                                        <div className="flex-shrink-0 me-3">
                                            <img src="/assets/images/users/avatar-2.jpg" className="avatar-sm rounded" alt="..." />
                                        </div>
    
                                        <div className="flex-grow-1">
                                            <h5 className="fs-15">Top Aligned media <small className="text-muted fs-13 fw-normal">- 15 Dec, 2021</small></h5>
                                            <p className="mb-1">Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                                            <p className="mb-0">Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                                        </div>
                                    </div>
    
                                    <div className="d-flex align-items-start text-muted mb-4">
                                        <div className="flex-shrink-0 me-3">
                                            <img src="/assets/images/users/avatar-6.jpg" className="avatar-sm rounded" alt="..." />
                                        </div>
    
                                        <div className="flex-grow-1">
                                            <h5 className="fs-15">Center Aligned media <small className="text-muted fs-13 fw-normal">- 10 Dec, 2022</small></h5>
                                            <p className="mb-1">Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                                            <p className="mb-0">Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                                        </div>
                                    </div>
    
                                    <div className="d-flex align-items-start text-muted">
                                        <div className="flex-shrink-0 me-3">
                                            <img src="/assets/images/users/avatar-8.jpg" className="avatar-sm rounded" alt="..." />
                                        </div>
    
                                        <div className="flex-grow-1">
                                            <h5 className="fs-15">Bottom Aligned media <small className="text-muted fs-13 fw-normal">- 15 Dec, 2021</small></h5>
                                            <p className="mb-1">Cras sit amet nibh libero, in gravida nulla. Nulla vel metus scelerisque ante sollicitudin. Cras purus odio, vestibulum in vulputate at, tempus viverra turpis. Fusce condimentum nunc ac nisi vulputate fringilla. Donec lacinia congue felis in faucibus.</p>
                                            <p className="mb-0">Donec sed odio dui. Nullam quis risus eget urna mollis ornare vel eu leo. Cum sociis natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end card-body --> */}
                        </div>
                        {/* <!-- end card --> */}
                    </div>
                    {/* <!-- end col --> */}
                </div>
            :
                <ComingSoon />
            }
        </>
    )
}